import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input, // Import Input for search
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import { filterItems } from "lib/helper"; // Import the filtering function
import * as XLSX from "xlsx"; // Import XLSX for exporting to Excel
import ExportButton from "components/ExportButton";
import usersModel from "models/users.model";
import Loader from "components/loader/Loader";
import TableHeader from "components/TableHeader/TableHeader";

const FeedbackPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [feedbackList, setFeedbackList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const navigate = useNavigate();

  const getReviews = async () => {
    setIsLoading(true);
    const response = await usersModel
      .getFeedback()
      .then((res) => {
        if (res) {
          setFeedbackList(res.reviews);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getReviews();
  }, []);

  const handleDelete = (id) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this Feedback", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          // Call the delete API
          usersModel
            .deleteFeedback(id)
            .then((res) => {
              if (res) {
                helper.sweetalert.toast(
                  "Feedback deleted successfully",
                  "success"
                );
                getReviews();
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
  };

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (item, index) => (currentPage - 1) * perPage + index + 1,
    },
    {
      label: "Username (Mobile)",
      getValue: (item) =>
        item?.user?.firstName +
        " " +
        item?.user?.lastName +
        " (" +
        item?.user?.mobileNo +
        ")",
    },
    {
      label: "Rating",
      getValue: (item) => item?.rating,
    },
    {
      label: "Feedback Experience",
      getValue: (item) => item?.description,
    },
    {
      label: "User Type",
      getValue: (item) => item?.user?.type,
    },
  ];

  const filteredFeedbackList = filterItems(
    feedbackList.map((e) => ({ ...e?.user, ...e })),
    searchQuery,
    ["firstName", "lastName", "mobileNo", "feedback", "type"]
  );

  const options = [
    "#",
    "Username (Mobile)",
    "Rating",
    "Feedback Experience",
    "User Type",
    "Actions",
  ];

  console.log("filter list", filteredFeedbackList);
  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Container className="pt-7" fluid>
        {!isLoading && (
          <Row>
            <div className="col pl-0 pr-0">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">Review & Rating</h3>
                  <div className="d-flex align-items-center">
                    <Input
                      type="text"
                      placeholder="Search Here..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: "200px", marginRight: "10px" }}
                    />
                    <ExportButton
                      columnsConfig={columnsConfig}
                      data={filteredFeedbackList}
                    />
                  </div>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <TableHeader options={options} />
                  <tbody>
                    {filteredFeedbackList
                      .slice((currentPage - 1) * perPage, currentPage * perPage)
                      .map((item, index) => {
                        return (
                          <tr key={item._id}>
                            <td>{(currentPage - 1) * perPage + index + 1}</td>
                            <td>
                              {item?.user?.firstName} {item?.user?.lastName} (
                              {item?.user?.mobileNo})
                            </td>
                            <td>{item?.rating}</td>
                            <td>
                              {item?.description?.length > 50
                                ? item?.description.slice(0, 50) + "..."
                                : item?.description}
                            </td>
                            <td>{item?.user?.type}</td>
                            <td>
                              <Button
                                color="success"
                                size="sm"
                                onClick={() =>
                                  navigate(
                                    `/admin/listings/experience-details/${item?.experience?._id}`
                                  )
                                }
                              >
                                <i className="fa-solid fa-eye"></i>
                              </Button>
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => handleDelete(item._id)}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </Button>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                    totalPages={Math.ceil(
                      filteredFeedbackList.length / perPage
                    )} // Total number of pages based on filtered feedback
                    currentPage={currentPage}
                    pageUrl="/admin/feedback?"
                  />
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};

export default FeedbackPage;
